/**
 * Cross-tab signal for "the Checkout tab reached an outcome" — success or
 * cancelled/rejected. The Checkout form deliberately opens with
 * rel="noopener" (severing window.opener is the actual security property; see
 * SubscriptionCard), so postMessage back to the opener isn't available. Both
 * tabs share an origin once Checkout redirects back to us, though, so
 * localStorage + the "storage" event (which fires in OTHER same-origin tabs,
 * not the one that wrote it) works without needing opener at all.
 */

const CHECKOUT_SIGNAL_KEY = "dc-checkout-result";

export function signalCheckoutResult(outcome: "success" | "cancelled") {
    try {
        localStorage.setItem(
            CHECKOUT_SIGNAL_KEY,
            JSON.stringify({
                outcome,
                at: Date.now(),
            }),
        );
    } catch {
        // Best effort — the bounded timeout in SubscriptionCard is the fallback
        // for private browsing / storage disabled.
    }
}

export function isCheckoutSignal(event: StorageEvent): boolean {
    return event.key === CHECKOUT_SIGNAL_KEY;
}
